module.exports = __webpack_public_path__ + "img/icon_growth.6571761a.svg";